import {useId} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {useElementWasVisible} from "@pg-mono/hooks";

import {AuthModalVariant} from "../../../auth/components/auth_modal/AuthModalHeaderVariants";
import {startRegistrationFlow} from "../../../auth/state/registration_flow_slice";
import {UnlockChoiceEntryPoint} from "../../../auth/types/UnlockChoiceEntryPoint";
import {useShouldHidePrices} from "../../../hooks/use_should_hide_prices";
import {useAppDispatch} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {PROPERTY_FAQ_ANSWER_AUTH_SOURCE, propertyFaqAnalytics} from "../../tracking/property_faq_tracking";

interface IProps {
    propertyId: number;
    offerId: number;
}

// Lorem ipsum filler rendered blurred behind the CTAs — deliberately NOT the real answer, which is never sent to
// non-verified users / Googlebot (SEO gating). Purely decorative, hidden from assistive tech.
const PLACEHOLDER_ANSWER =
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";

export const PropertyDetailFaqAnswerGate = (props: IProps) => {
    const {propertyId, offerId} = props;
    const dispatch = useAppDispatch();
    const {hasCompleteProfile, hasPhoneVerified, isUserLoggedIn} = useShouldHidePrices();
    const shouldVerifyPhone = isUserLoggedIn && !hasPhoneVerified;
    const paywallTrackingId = `property-faq-answer-paywall-${useId()}`;

    useElementWasVisible({
        ids: [paywallTrackingId],
        onElementVisible: () => propertyFaqAnalytics.gtm.answerPaywallView(),
        once: true,
        threshold: 0.05
    });

    const openAuthModal = (clickText: string, showLoginForm?: boolean) => {
        propertyFaqAnalytics.gtm.answerCtaClick(clickText);
        dispatch(
            startRegistrationFlow({
                isUserLoggedIn,
                hasCompleteProfile,
                hasPhoneVerified,
                userSource: UserSource.REGISTRATION,
                gtmSourceSection: PROPERTY_FAQ_ANSWER_AUTH_SOURCE,
                titleVariant: AuthModalVariant.PROPERTY_FAQ,
                amplitudePlacement: "rp_property_faq",
                propertyId,
                offerId,
                showLoginForm,
                unlockChoiceEntryPoint: UnlockChoiceEntryPoint.FAQ
            })
        );
    };

    return (
        <div data-id={paywallTrackingId} className={lockedWrapperStyle}>
            <div className={blurredAnswerStyle} aria-hidden>
                <Text variant="info_txt_1" as="p">
                    {PLACEHOLDER_ANSWER}
                </Text>
            </div>

            <div className={ctaOverlayStyle}>
                {shouldVerifyPhone ? (
                    <Button variant="filled_secondary" size="small" className={ctaButtonStyle} onClick={() => openAuthModal("Zweryfikuj telefon")}>
                        Zweryfikuj telefon
                    </Button>
                ) : !isUserLoggedIn ? (
                    <>
                        <Button variant="filled_secondary" size="small" className={ctaButtonStyle} onClick={() => openAuthModal("Zarejestruj się")}>
                            Zarejestruj się
                        </Button>

                        <Button variant="none_secondary" size="small" className={ctaButtonStyle} onClick={() => openAuthModal("Zaloguj się", true)}>
                            Zaloguj się
                        </Button>
                    </>
                ) : null}
            </div>
        </div>
    );
};

const lockedWrapperStyle = css({
    position: "relative",
    width: "100%",
    minHeight: "13.6rem"
});

const blurredAnswerStyle = css({
    width: "100%",
    filter: "blur(6px)",
    userSelect: "none",
    pointerEvents: "none"
});

const ctaOverlayStyle = css({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1
});

const ctaButtonStyle = css({
    width: "200px"
});
import {useId} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {useElementWasVisible} from "@pg-mono/hooks";

import {AuthModalVariant} from "../../../auth/components/auth_modal/AuthModalHeaderVariants";
import {startRegistrationFlow} from "../../../auth/state/registration_flow_slice";
import {UnlockChoiceEntryPoint} from "../../../auth/types/UnlockChoiceEntryPoint";
import {useShouldHidePrices} from "../../../hooks/use_should_hide_prices";
import {useAppDispatch} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {PROPERTY_FAQ_ANSWER_AUTH_SOURCE, propertyFaqAnalytics} from "../../tracking/property_faq_tracking";

interface IProps {
    propertyId: number;
    offerId: number;
}

// Lorem ipsum filler rendered blurred behind the CTAs — deliberately NOT the real answer, which is never sent to
// non-verified users / Googlebot (SEO gating). Purely decorative, hidden from assistive tech.
const PLACEHOLDER_ANSWER =
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";

export const PropertyDetailFaqAnswerGate = (props: IProps) => {
    const {propertyId, offerId} = props;
    const dispatch = useAppDispatch();
    const {hasCompleteProfile, hasPhoneVerified, isUserLoggedIn} = useShouldHidePrices();
    const shouldVerifyPhone = isUserLoggedIn && !hasPhoneVerified;
    const paywallTrackingId = `property-faq-answer-paywall-${useId()}`;

    useElementWasVisible({
        ids: [paywallTrackingId],
        onElementVisible: () => propertyFaqAnalytics.gtm.answerPaywallView(),
        once: true,
        threshold: 0.05
    });

    const openAuthModal = (clickText: string, showLoginForm?: boolean) => {
        propertyFaqAnalytics.gtm.answerCtaClick(clickText);
        dispatch(
            startRegistrationFlow({
                isUserLoggedIn,
                hasCompleteProfile,
                hasPhoneVerified,
                userSource: UserSource.REGISTRATION,
                gtmSourceSection: PROPERTY_FAQ_ANSWER_AUTH_SOURCE,
                titleVariant: AuthModalVariant.PROPERTY_FAQ,
                amplitudePlacement: "rp_property_faq",
                propertyId,
                offerId,
                showLoginForm,
                unlockChoiceEntryPoint: UnlockChoiceEntryPoint.FAQ
            })
        );
    };

    return (
        <div data-id={paywallTrackingId} className={lockedWrapperStyle}>
            <div className={blurredAnswerStyle} aria-hidden>
                <Text variant="info_txt_1" as="p">
                    {PLACEHOLDER_ANSWER}
                </Text>
            </div>

            <div className={ctaOverlayStyle}>
                {shouldVerifyPhone ? (
                    <Button variant="filled_secondary" size="small" className={ctaButtonStyle} onClick={() => openAuthModal("Zweryfikuj telefon")}>
                        Zweryfikuj telefon
                    </Button>
                ) : !isUserLoggedIn ? (
                    <>
                        <Button variant="filled_secondary" size="small" className={ctaButtonStyle} onClick={() => openAuthModal("Zarejestruj się")}>
                            Zarejestruj się
                        </Button>

                        <Button variant="none_secondary" size="small" className={ctaButtonStyle} onClick={() => openAuthModal("Zaloguj się", true)}>
                            Zaloguj się
                        </Button>
                    </>
                ) : null}
            </div>
        </div>
    );
};

const lockedWrapperStyle = css({
    position: "relative",
    width: "100%",
    minHeight: "13.6rem"
});

const blurredAnswerStyle = css({
    width: "100%",
    filter: "blur(6px)",
    userSelect: "none",
    pointerEvents: "none"
});

const ctaOverlayStyle = css({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1
});

const ctaButtonStyle = css({
    width: "200px"
});
